import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  return <section className="relative w-full bg-white pt-12 pb-16 px-4 sm:px-6 lg:px-8 overflow-hidden" data-id="element-80">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-81">
        {/* Text Content */}
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6
      }} className="flex flex-col gap-6 text-center lg:text-left" data-id="element-82">
          <div className="inline-block px-3 py-1 bg-green-50 text-[#0B6B3A] text-sm font-semibold rounded-full w-fit mx-auto lg:mx-0" data-id="element-83">
            Nuevo Sistema de Ventas
          </div>

          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-[#1A1A1A] leading-tight tracking-tight" data-id="element-84">
            Te preguntan <span className="text-[#0B6B3A]" data-id="element-85">"¿precio?"</span> y
            desaparecen: esto es lo que respondes
          </h1>

          <p className="text-lg sm:text-xl text-gray-600 max-w-2xl mx-auto lg:mx-0" data-id="element-86">
            25 mensajes listos para cerrar ventas por DM/WhatsApp (sin sonar
            desesperado).
          </p>

          <div className="pt-4" data-id="element-87">
            <a href="#comprar" className="inline-flex items-center justify-center gap-2 bg-[#0B6B3A] hover:bg-[#095c32] text-white text-lg font-bold py-4 px-8 rounded-xl shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 w-full sm:w-auto" data-id="element-88">
              Quiero el sistema → $6.39
            </a>
            <p className="mt-3 text-sm text-gray-500" data-id="element-89">
              ⚡ Acceso inmediato · PDF Digital
            </p>
          </div>
        </motion.div>

        {/* Image Content */}
        <motion.div initial={{
        opacity: 0,
        x: 20,
        scale: 0.95
      }} animate={{
        opacity: 1,
        x: 0,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative mx-auto w-full max-w-md lg:max-w-full" data-id="element-90">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl border-4 border-gray-100 bg-gray-50 aspect-[4/5] lg:aspect-square flex items-center justify-center" data-id="element-91">
            <img src="https://cdn.magicpatterns.com/uploads/3Qj7SYK99UxV2q2YTF2dZK/heylloyd-image-1770879405472.png" alt="DM/WhatsApp Cierre Rápido en Tablet" className="w-full h-full object-cover" data-id="element-92" />

            {/* Floating Badge */}
            <div className="absolute bottom-6 right-6 bg-white/95 backdrop-blur-sm p-4 rounded-xl shadow-lg border border-gray-100 max-w-[200px]" data-id="element-93">
              <div className="flex items-center gap-2 mb-1" data-id="element-94">
                <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse" data-id="element-95"></div>
                <span className="text-xs font-bold text-gray-500 uppercase" data-id="element-96">
                  Resultado
                </span>
              </div>
              <p className="text-sm font-medium text-gray-800" data-id="element-97">
                "Nunca más te quedes en blanco cuando te pregunten el precio."
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}